import { createTheme } from "@mui/material";

declare module '@mui/material/styles' {
  interface Palette {
    black: Palette['primary'];
    gray: Palette['primary'];
  }

  interface PaletteOptions {
    black?: PaletteOptions['primary'];
    gray?: PaletteOptions['primary'];
  }
}

declare module '@mui/material/Button' {
  interface ButtonPropsColorOverrides {
    black: true;
    gray: true;
  }
}

export const theme = createTheme({
  palette: {
    primary: {
      main: '#1E88E5',
    },
    black: {
      main: '#414141',
    },
    gray: {
      main: '#C0C0C0',
    },
    success: {
      main: "#66BB6B",
    }
  },
  components: {
    MuiButton: {
      styleOverrides: {
        root: {
          textTransform: 'none',
        },
      },
    },
    MuiCard: {
      styleOverrides: {
        root: {
          padding: '16px',
        },
      },
    },
    MuiAvatar: {
      styleOverrides: {
        img: {
          objectFit: 'contain',
        },
      },
    },
  },
});
